import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../../view/partials/Header";
import Sidebar from "../../view/partials/Sidebar";
import AccountBlockedBanner from "../AccountBlockedBanner";
import "../../asset/style/dashboard.css";

const DashboardLayout = () => {
  const [isOpenS, setIsOpens] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const isApp = Number(localStorage.getItem("isApp"));


  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsOpens(false);
    } else {
      setIsOpens(true);
    }
  };
  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="sidebar-mini layout-fixed">
        {!isApp && <Header setIsOpens={setIsOpens} isOpenS={isOpenS} />}
        <div className="app-main">
          <div className="app-sidebar">
            {!isApp && (
              <Sidebar
                setIsOpens={setIsOpens}
                isOpenS={isOpenS}
                setIsHovered={setIsHovered}
                isHovered={isHovered}
              />
            )}
          </div>
          <div
            className={`content-wrapper ${!isApp ? "ms-md" : "ms-0"}`}
            style={{
              // marginLeft: isOpenS ? "250px" : "60px" || isHovered === true ? "60px" : "250px",
              marginLeft: !isApp
                ? isHovered || isOpenS
                  ? "250px"
                  : "60px"
                : "0px",

              transition: "margin-left 0.3s ease",
            }}
          >
            <AccountBlockedBanner />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
